import { useCallback, useMemo, useState } from 'react';

type TDisclosureTriggers = {
  onOpen: () => void;
  onClose: () => void;
};

type InitialState = boolean | (() => boolean);

export const useDisclosure = (initialState: InitialState = false, triggers: Partial<TDisclosureTriggers> = {}) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = useCallback(() => {
    setIsOpen(true);
    triggers.onOpen?.();
  }, [triggers.onOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
    triggers.onClose?.();
  }, [triggers.onClose]);

  const toggle = useCallback(() => {
    setIsOpen((prevIsOpen) => {
      const nowIsOpen = !prevIsOpen;
      if (nowIsOpen) {
        triggers.onOpen?.();
      } else {
        triggers.onClose?.();
      }
      return nowIsOpen;
    });
  }, [triggers.onOpen, triggers.onClose]);

  return useMemo(
    () => ({
      isOpen,
      open,
      close,
      toggle
    }),
    [isOpen, open, close, toggle]
  );
};
